import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf6cf6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 container" }
const _hoisted_2 = { class: "fs-5" }
const _hoisted_3 = { class: "text-start border border-2 mt-5 fs-6" }
const _hoisted_4 = { class: "col-auto col-form-label" }
const _hoisted_5 = { class: "col-auto col-form-label" }
const _hoisted_6 = { class: "d-flex justify-content-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "最初に戻る", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_4, "車台番号：" + _toDisplayString($setup.vinNo), 1 /* TEXT */)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_5, "シリアル番号：" + _toDisplayString($setup.serialNo), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary mt-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.returnInitialPage()))
        }, _hoisted_8)
      ])
    ])
  ]))
}